import { createContractRequest } from './helper';
export const deleteOffer = createContractRequest({
    route: '/contract/offers/:offerId',
    method: 'delete',
    source: 'data',
});
